import Repository from "../Repository";

const resource = "/formulas";
export default {
    get(){
        return Repository.get(`${resource}`);
    },
    getFormula(formulaId){
        return Repository.get(`${resource}/${formulaId}`);
    },
    createFormula(json){
        return Repository.post(`${resource}`,json);
    },
    updateFormula(formulaId,json){
        return Repository.put(`${resource}/${formulaId}`,json);
    },
    deleteFormula(formulaId){
        return Repository.delete(`${resource}/${formulaId}`);
    }
}